import React, { useState, useRef, FC, useEffect, useContext } from 'react'
import useOnClickOutside from '../../../../app/hooks/useOnClickOutside'
import { EditElementWrapper } from '../EditElementWrapper'
import '@capaj/react-quill/dist/quill.bubble.css'
import './EditQuizElement.less'

import { QuizEditMode } from './QuizEditMode'
import { elementShouldStayInEditingMode } from '../utils'
import { TopicElementModelAsEditor } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { useDebouncedCallback } from 'use-debounce'
import { TopicEditingContext } from '../../../topic-edit-page/TopicEditContext'

export const EditQuizElement: FC<{
  element: TopicElementModelAsEditor
  isMultiPage?: boolean
}> = (props) => {
  const { element, isMultiPage } = props
  const [content, setContent] = useState<string>(element.data?.content || '')
  const [editing, setEditing] = useState(
    elementShouldStayInEditingMode(!!isMultiPage, content)
  )
  const topicEditingCtx = useContext(TopicEditingContext)

  const wrapperRef = useRef(null)

  const debouncedUpdateElement = useDebouncedCallback(
    (content) =>
      topicEditingCtx.updateElement(element.id, {
        data: { content }
      }),
    1000
  )

  useEffect(() => {
    if (content) {
      debouncedUpdateElement(content)
    }
    return debouncedUpdateElement.flush
  }, [content])

  useOnClickOutside(wrapperRef, () => {
    setEditing(elementShouldStayInEditingMode(!!isMultiPage, content))
  })

  return (
    <div ref={wrapperRef}>
      <EditElementWrapper {...props}>
        <div
          className="element-quiz element-mode-view"
          onClick={() => setEditing(true)}
        >
          <QuizEditMode
            element={element}
            editing={editing}
            setEditing={setEditing}
            content={content}
            setContent={setContent}
          />
        </div>
      </EditElementWrapper>
    </div>
  )
}
